import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';

interface IPropsDialog {
  open: boolean;
  onClose: (action: string) => void;
}

const NoActiveElectionsDialog: React.FC<IPropsDialog> = ({open, onClose}) => {
  const {t} = useTranslation();
  const [countdown, setCountdown] = useState(8);
  let timer: NodeJS.Timeout;

  useEffect(() => {
    if (open) {
      setCountdown(8);
      timer = setInterval(() => {
        setCountdown(prev => {
          if (prev === 1) {
            closeAndRedirect();
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [open, onClose]);

  const closeAndRedirect = () => {
    clearInterval(timer);
    onClose('confirm');
  };

  const noRedirect = () => {
    clearInterval(timer);
    onClose('cancel');
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={closeAndRedirect}
      disableBackdropClick={true}
      className="competitor-detail-dialog"
    >
      <DialogTitle>
        <h4>{t('sem-votacao-dialog.titulo-sem-votacao')}</h4>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>
            <Trans
              i18nKey="sem-votacao-dialog.redirecionamento-mensagem"
              shouldUnescape={true}
              components={{strong: <strong />}}
              values={{
                characters: escape('<, >, &'),
                countdown,
              }}
            />
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className="button-default "
          type="button"
          variant="contained"
          onClick={closeAndRedirect}
        >
          {t('sem-votacao-dialog.btn-encerrar')}
        </Button>
        <Button
          className="button-default btn-color-green"
          type="button"
          variant="outlined"
          onClick={noRedirect}
        >
          {t('sem-votacao-dialog.btn-continuar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoActiveElectionsDialog;



// WEBPACK FOOTER //
// ./src/features/election/components/NoActiveElectionsDialog.tsx